import React from "react";
import { Form, Formik } from "formik";

export default function FormikForm({
  children,
  enableReinitialize = true,
  initialValues,
  validationSchema,
  onSubmit,
}) {
  return (
    <Formik
      enableReinitialize={enableReinitialize}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      initialValues={initialValues}
    >
      {() => <Form>{children}</Form>}
    </Formik>
  );
}
